// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { DoctorsState } from '../_reducers/doctor.reducers';
import { each } from 'lodash-es';
import { Doctor } from '../_models/doctor.model';

export const selectDoctorsState = createFeatureSelector<DoctorsState>('doctors');

export const selectDoctorById = (doctorId: number) =>
  createSelector(selectDoctorsState, (doctorsState) => doctorsState.entities[doctorId]);

export const selectDoctorsPageLoading = createSelector(selectDoctorsState, (doctorsState) => {
  return doctorsState.listLoading;
});

export const selectDoctorsActionLoading = createSelector(
  selectDoctorsState,
  (doctorsState) => doctorsState.actionsloading,
);

export const selectLastCreatedDoctorId = createSelector(
  selectDoctorsState,
  (doctorsState) => doctorsState.lastCreatedDoctorId,
);

export const selectLastCreatedDoctor = createSelector(
  selectDoctorsState,
  (doctorsState) => doctorsState.lastCreatedDoctor,
);

export const selectDoctorsPageLastQuery = createSelector(
  selectDoctorsState,
  (doctorsState) => doctorsState.lastQuery,
);
export const selectErrorState = createSelector(
  selectDoctorsState,
  (doctorsState) => doctorsState.error,
);

export const selectDoctorLatestSuccessfullAction = createSelector(
  selectDoctorsState,
  (doctorsState) => doctorsState.latestSuccessfullAction,
);
export const selectDoctorsInStore = createSelector(selectDoctorsState, (doctorsState) => {
  const items: Doctor[] = [];
  each(doctorsState.ids, (ele) => {
    const index: number = +ele;
    items.push(doctorsState.entities[index]);
  });
  return new QueryResultsModel(items, doctorsState.totalCount);
});

export const selectDoctorsShowInitWaitingMessage = createSelector(
  selectDoctorsState,
  (doctorsState) => doctorsState.showInitWaitingMessage,
);

export const selectHasDoctorsInStore = createSelector(selectDoctorsState, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }

  return true;
});
